;(function() {
/* @ngInject */
function Toast($window) {
  const show = (method, text) => {
    if ($window.firmarenToast) {
      $window.firmarenToast[method](text);
    }
  };

  return {
    showInfo: (text) => show("showInfo", text),
    showSuccess: (text) => show("showSuccess", text),
    showError: (text) => show("showError", text),
    showWarning: (text) => show("showWarning", text)
  };
}

angular.module("firmaren").factory("Toast", Toast);
}());
